
import router from '@/routes'
import storage from '@/utils/storage'

const state = {
  user: {},
  settings: {}
}

const actions = {
  setUser ({commit}, user) {
    commit('set_user', user)
  },
  removeUser ({commit}) {
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    commit('set_user', {})
  },
  logout () {
    router.push({
      name: 'logout'
    })
  }
}

const mutations = {
  set_user (state, user) {
    state.user = user;
    // console.log('store set_user: ', user)
    storage.save('muser', user);
  },
  GET_settings (state) {
    this._vm.$http
    .post('service/settings')
    .then(response => {
      // console.log('GET_settings');
      state.settings = Object.fromEntries(response.data.map(item => [item.variable, item.value]));
    })
    .catch(function (error) {
      console.log('Error - get_settings store: ', error);
    });
  }
}

const getters = {
  user: (state) => {
    return (state.user && state.user.id) ? state.user : storage.load('muser');
  },
  settings: (state) => {
    return state.settings || {};
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}
